import React, { useState } from "react";
import { Space } from "@masterteam/mt-design-react";

import "./style.scss";

const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <Space direction="vertical" className="content">
      <Space size="large" className="tabs-wrapper">
        {tabs.map((item) => (
          <Space
            key={item.ID}
            onClick={() => setActiveTab(item)}
            className={`tab-item cursor ${
              activeTab.ID === item.ID && "active"
            }`}
          >
            <div>{item.name}</div>
          </Space>
        ))}
      </Space>
      {activeTab.component}
    </Space>
  );
};

export default Tabs;
